import { GlobalState } from "little-state-machine";

export const updateActionsFiltered = (state: GlobalState, actionsFiltered: string[]) => ({
  ...state,
  actionsFiltered
});
